module.exports = __webpack_public_path__ + "static/img/zixun.59c10d3c.png";